import { useState, useEffect } from "react";
import { Sidebar } from "../../components/NewOrderComponents/Sidebar";
import { TopActionBar } from "../../components/NewOrderComponents/TopActionBar";
import { FoodItem } from "../../components/NewOrderComponents/FoodItem";
import { OrderSummary } from "../../components/NewOrderComponents/OrderSummary";
import { ProductDetailModal } from "../../components/NewOrderComponents/ProductDetailModal";
import { postRequest } from "../../services/mainApp.service";
import { useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import { SET_COLLAPSABLE } from "../../redux/reduxConstants";
import { Search } from "lucide-react";
import { Input } from "../../components/ui/input";
import { CustomerOrderHistoryDialog } from "../../components/NewOrderComponents/CustomerOrderHistoryDialog";
import { ItemLessReasonDialog } from "../../components/NewOrderComponents/ItemLessReasonDialog";
import { NewOrderDialog } from "../../components/NewOrderComponents/NewOrderDialog";
import { OrderCancelReasonDialog } from "../../components/NewOrderComponents/OrderCancelReasonDialog";
import { message } from "antd";
import { AGENT, MANAGEMENT } from "../../common/SetupMasterEnum";

// const Index = () => {
function CDMS() {
  const [activeCategory, setActiveCategory] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const userData = useSelector((state) => state.authReducer);
  const { collapsable } = useSelector((state) => state.authReducer);
  const [activeMode, setActiveMode] = useState("takeaway");
  const [orderItems, setOrderItems] = useState([]);
  const [currentOrder, setCurrentOrder] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showProductModal, setShowProductModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [isRecalledOrder, setIsRecalledOrder] = useState(false);
  const [lastOrderId, setLastOrderId] = useState(null);
  const [isOrderHistoryOpen, setIsOrderHistoryOpen] = useState(false);
  const location = useLocation();
  const dispatch = useDispatch();
  const { order } = location?.state || {};
  const [DayShiftCounterData, setDayShiftCounterData] = useState({});
  const POSData = useSelector((state) => state.POSReducer);
  const [itemLessReason, setItemLessReason] = useState([]);
  const [showItemLessReasonDialog, setShowItemLessReasonDialog] = useState(false);
  const [pendingQuantityUpdate, setPendingQuantityUpdate] = useState(null);
  const [pendingItemForReason, setPendingItemForReason] = useState(null);
  const [isNewOrderDialogOpen, setIsNewOrderDialogOpen] = useState(false);

  const [orderKotItems, setOrderKotItems] = useState([]);
  const [orderMode, setOrderMode] = useState([]);

  const [orderCancelReason, setOrderCancelReason] = useState([]);
  const [showOrderCancelReasonDialog, setShowOrderCancelReasonDialog] = useState(false);

  // // // console.log("current",currentOrder);

  const areDealSelectionsEqual = (sel1, sel2) => {
    if (!sel1 && !sel2) return true;

    if (!sel1 || !sel2) return false;

    const keys1 = Object.keys(sel1);
    const keys2 = Object.keys(sel2);

    if (keys1.length !== keys2.length) return false;

    for (let key of keys1) {
      if (sel1[key] && !Array.isArray(sel1[key]) && sel2[key] && !Array.isArray(sel2[key])) {
        if (sel1[key].id !== sel2[key].id) return false;
      }
      else if (Array.isArray(sel1[key]) && Array.isArray(sel2[key])) {
        if (sel1[key].length !== sel2[key].length) return false;

        const sorted1 = [...sel1[key]].sort((a, b) => a.id - b.id);
        const sorted2 = [...sel2[key]].sort((a, b) => a.id - b.id);

        for (let i = 0; i < sorted1.length; i++) {
          if (sorted1[i].id !== sorted2[i].id) return false;
        }
      } else {
        return false;
      }
    }

    return true;
  };

  const handleAddItemKot = (product, prod) => {


    const {
      ProductId,
      ProductName,
      Price,
      FlavourId,
      ProductDetailId,
      ProductDetailName,
      FlavourName,
      GSTPercentage,
      ProductDescription,
      ProductImage
    } = prod;


    const item = orderKotItems
      .find(i => i.ProductDetailId === ProductDetailId
        && i.IsKot === false && i.IsLess === false);

    if (item) {
      const qty = product.quantity || 1;

      setOrderKotItems(orderKotItems.map(item =>
        item.ProductDetailId === ProductDetailId &&
          (!item.dealSelections || Object.keys(item.dealSelections).length === 0)
          && item.IsKot === false
          ? { ...item, quantity: item.quantity + qty }
          : item
      ));
    }
    else {

      const newKotItem = {
        ...product
        , id: Date.now()
        , IsLess: false
        , IsKot: false
        , ProductDetailId: ProductDetailId
        , quantity: 1
      };
      setOrderKotItems([...orderKotItems, newKotItem]);

    }
  };

  const handleItemSelect = (product) => {

    let prod = null;

    if (product.ProductDetailCount > 1 || product.IsDeal) {
      setSelectedProduct(product);
      setShowProductModal(true);
      return;
    }

    if (currentOrder && currentOrder.Table) {
      const tableProduct = currentOrder.Table.find(
        item => item.ProductId === product.ProductId
      );

      prod = tableProduct;

      if (tableProduct) {
        const {
          ProductId,
          ProductName,
          Price,
          FlavourId,
          ProductDetailId,
          ProductDetailName,
          FlavourName,
          GSTPercentage,
          ProductDescription,
          ProductImage,
          DepartmentId,
          DepartmentName
        } = tableProduct;

        const existingItem = orderItems.find(item =>
          item.ProductId === ProductId &&
          item.FlavourId === FlavourId &&
          (!item.dealSelections || Object.keys(item.dealSelections).length === 0)
          && item.OrderDetailId === undefined
          // && item.IsKot === false
        );

        if (existingItem) {
          setOrderItems(orderItems.map(item =>
            item.ProductId === ProductId &&
              item.FlavourId === FlavourId &&
              (!item.dealSelections || Object.keys(item.dealSelections).length === 0)
              && item.OrderDetailId === undefined
              // && item.IsKot === false
              ? { ...item, quantity: item.quantity + 1 }
              : item
          ));
        } else {
          const newItem = {
            id: Date.now(),
            ProductId,
            ProductDetailId,
            ProductDetailName,
            name: ProductName,
            quantity: 1,
            price: Price,
            description: ProductDescription,
            image: ProductImage,
            FlavourId,
            FlavourName,
            GSTPercentage,
            // IsKot: false,
            dealSelections: {}, // Initialize empty dealSelections
            optionQuantities: {}, // Initialize empty optionQuantities
            DepartmentId,
            DepartmentName
          };
          setOrderItems([...orderItems, newItem]);
        }
      } else {
        console.error("Product not found in Table array:", product.ProductId);
        const existingItem = orderItems.find(item =>
          item.ProductId === product.ProductId &&
          (!item.dealSelections || Object.keys(item.dealSelections).length === 0)
        );

        if (existingItem) {
          setOrderItems(orderItems.map(item =>
            item.ProductId === product.ProductId &&
              (!item.dealSelections || Object.keys(item.dealSelections).length === 0)
              ? { ...item, quantity: item.quantity + 1 }
              : item
          ));
        } else {
          const newItem = {
            id: Date.now(),
            ProductId: product.ProductId,
            name: product.ProductName,
            quantity: 1,
            price: product.ProductPrice,
            description: product.ProductDescription,
            image: product.ProductImage,
            FlavourId: null,
            FlavourName: null,
            GSTPercentage: product.GSTPercentage || 0,
            // IsKot: false,
            dealSelections: {}, // Initialize empty dealSelections
            optionQuantities: {}, // Initialize empty optionQuantities
            DepartmentId,
            DepartmentName
          };
          setOrderItems([...orderItems, newItem]);
        }
      }
    } else {
      console.error("Table data not available in currentOrder");
      // Fallback to the original product data
      const existingItem = orderItems.find(item =>
        item.ProductId === product.ProductId &&
        (!item.dealSelections || Object.keys(item.dealSelections).length === 0)
      );

      if (existingItem) {
        setOrderItems(orderItems.map(item =>
          item.ProductId === product.ProductId &&
            (!item.dealSelections || Object.keys(item.dealSelections).length === 0)
            ? { ...item, quantity: item.quantity + 1 }
            : item
        ));
      } else {
        const newItem = {
          id: Date.now(),
          ProductId: product.ProductId,
          name: product.ProductName,
          quantity: 1,
          price: product.ProductPrice,
          description: product.ProductDescription,
          image: product.ProductImage,
          FlavourId: null,
          FlavourName: null,
          GSTPercentage: product.GSTPercentage || 0,
          // IsKot: false,
          dealSelections: {}, // Initialize empty dealSelections
          optionQuantities: {}, // Initialize empty optionQuantities
          DepartmentId,
          DepartmentName
        };
        setOrderItems([...orderItems, newItem]);
      }
    }

    handleAddItemKot(product, prod);
  };

  const resetRecalledOrderState = () => {
    setIsRecalledOrder(false);
    setLastOrderId(null);

    // Clear the current order data related to the recalled order
    setCurrentOrder(null);

    // Clear the order items from the recalled order
    setOrderItems([]);

    // Reset any other recalled order specific states
    // You might also want to reset categories and products to initial state
    setCategories([]);
    setProducts([]);

    setOrderKotItems([]);

    // If you have any other states specific to recalled orders, reset them here
  };

  useEffect(() => {
    if (!collapsable) {
      dispatch({ type: SET_COLLAPSABLE, payload: true });
    }
  }, [dispatch, collapsable]);

  useEffect(() => {

    if (order) {

      const savedOrderId = order?.OrderMasterId;
      if (savedOrderId) {
        setLastOrderId(parseInt(savedOrderId));
        setIsRecalledOrder(false);
        recallLastOrder(parseInt(savedOrderId));
      }
    }

    getDayShiftCounterData();
    fetchOrderModeData();

  }, []);

  // Watch for POSData.DayShiftCounter changes and update when data is available
  useEffect(() => {

    getDayShiftCounterData();

  }, [POSData]);

  const getDayShiftCounterData = () => {

    if (userData.RoleId != AGENT) {
      let selectedTerminalId = localStorage.getItem('SelectedTerminalId');

      if (selectedTerminalId != null) {
        // Ensure DayShiftCounter is an array before calling find
        const dayShiftCounter = Array.isArray(POSData?.DayShiftCounter)
          ? POSData.DayShiftCounter
          : [];

        const currentTerminal = dayShiftCounter.find(a => a.IsSelected == true && a.TerminalId == selectedTerminalId) ?? null;

        if (currentTerminal?.IsSelected) {
          setDayShiftCounterData(currentTerminal);
        }
      }
    }
    else {
      setDayShiftCounterData({});
    }
  };

  const handleRemoveItem = (itemId) => {
    setOrderItems(orderItems.filter(item => item.id !== itemId));
  };

  const handleUpdateItems = (updatedItems) => {
    setOrderItems(updatedItems);
  };

  const handleUpdateItemsCallback = (updateFn) => {
    setOrderItems(prevItems => {
      const updatedItems = updateFn(prevItems);

      // Also update orderKotItems to keep them in sync
      setOrderKotItems(prevKotItems => {
        // Find items that were removed (in prevItems but not in updatedItems)
        const updatedItemIds = new Set(updatedItems.map(item => item.id));
        const removedItemIds = prevItems
          .filter(item => !updatedItemIds.has(item.id))
          .map(item => item.id);

        // Remove deleted items from KOT items, but only if they haven't been printed (IsKot === false)
        let newKotItems = prevKotItems.filter(kotItem => {
          // Keep items that weren't removed
          if (!removedItemIds.includes(kotItem.id)) {
            return true;
          }
          // For removed items, only remove if they haven't been printed
          return kotItem.IsKot === true;
        });

        // Update existing items or add new ones
        updatedItems.forEach(updatedItem => {
          const existingKotIndex = newKotItems.findIndex(kotItem => kotItem.id === updatedItem.id);

          if (existingKotIndex !== -1) {
            // Update existing KOT item, but only if it hasn't been printed
            const existingKotItem = newKotItems[existingKotIndex];
            if (existingKotItem.IsKot === false || existingKotItem.IsKot === undefined) {
              newKotItems[existingKotIndex] = {
                ...updatedItem,
                // Preserve KOT-specific properties
                IsKot: false,
                IsLess: existingKotItem.IsLess !== undefined ? existingKotItem.IsLess : false,
                ItemLessReason: existingKotItem.ItemLessReason,
                ItemLessReasonId: existingKotItem.ItemLessReasonId,
              };
            }
            // If IsKot === true, don't update (item already printed)
          } else {
            // Add new item to KOT items (only if it's not already marked as printed)
            // Items with IsKot === false or undefined are pending KOT generation
            if (updatedItem.IsKot === false || updatedItem.IsKot === undefined) {
              newKotItems.push({
                ...updatedItem,
                IsKot: false,
                IsLess: false,
              });
            }
          }
        });

        return newKotItems;
      });

      return updatedItems;
    });
  };

  const handleClearAll = () => {
    setOrderItems([]);
    setCurrentOrder(null);
    setCategories([]);
    setProducts([]);
    setIsRecalledOrder(false);
    setLastOrderId(null);
    setOrderKotItems([]);
  };

  const handlePayment = () => {
    // // console.log("Processing payment for:", orderItems);
  };

  const handleNewOrder = (orderData) => {
    console.log("handleNewOrder called with orderData:", orderData);

    setCurrentOrder(orderData);
    if (orderData.categories) {
      setCategories(orderData.categories);
    }
    if (orderData.products) {
      setProducts(orderData.products);
    }
  };

  const fetchMenuData = async (branchId, areaId, orderSourceId) => {

    setIsLoading(true);
    try {
      const menuResponse = await postRequest("CrudMenu", {
        DisplayInPos: true,
        DisplayInWeb: false,
        DisplayInOdms: false,
        DisplayInMobile: false,
        BranchId: branchId || null,
        AreaId: areaId || null,
        Barcode: "",
        CompanyId: userData.CompanyId,
        OrderSourceId: orderSourceId || null
      });

      if (menuResponse.data.Response) {

        const Table = menuResponse.data.DataSet?.Table || [];
        const categories = menuResponse.data.DataSet?.Table1 || [];
        const products = menuResponse.data.DataSet?.Table2 || [];
        const Table6 = menuResponse.data.DataSet?.Table6 || [];
        const Table3 = menuResponse.data.DataSet?.Table3 || [];
        const Table4 = menuResponse.data.DataSet?.Table4 || [];
        const Table11 = menuResponse.data.DataSet?.Table11 || [];
        const Table14 = menuResponse.data.DataSet?.Table14 || [];
        const Data = menuResponse.data.Data || {};
        const Table15 = menuResponse.data.DataSet?.Table15 || [];

        const discountMaster = menuResponse.data.DataSet?.Table13 || [];
        const discountDetail = menuResponse.data.DataSet?.Table14 || [];
        const paymentTerms = menuResponse.data.DataSet?.Table16 || [];
        return {
          categories,
          products,
          Table,
          Table6,
          Table3,
          Table4,
          Table11,
          Table14,
          Data,
          Table15,
          discountMaster,
          discountDetail,
          // branchName: selectedBranchName,
          paymentTerms
        };
      }
    } catch (error) {
      console.error("Error fetching menu data:", error);
      throw error;
    } finally {
      setIsLoading(false);
    }
    return null;
  };

  const fetchOrderModeData = async () => {

    setIsLoading(true);
    try {
      const response = await postRequest("CrudOrderSource", {
        OperationId: 6,
        CompanyId: userData.CompanyId,
        UserId: userData.UserId,
      });

      if (response.data.Response) {

        const OrderModeOrderSourceArr = response.data.DataSet?.Table || [];

        const arr = userData.RoleId == AGENT ?
          OrderModeOrderSourceArr.filter(a => a.OrderModeFlex != 'DINE IN' && a.OrderSourceFlex != 'POS') :
          OrderModeOrderSourceArr;

        const OrderModeOrderSource = [
          ...new Map(arr.map(item => [item.OrderModeId, item])).values()
        ];
        setOrderMode(OrderModeOrderSource);
      }
    } catch (error) {
      console.error("Error fetching Order Mode & Order Source:", error);
      throw error;
    } finally {
      setIsLoading(false);
    }
    return null;
  };

  const recallLastOrder = async (lastOrderId) => {

    if (!lastOrderId) {
      alert("No recent order to recall");
      return;
    }

    try {
      const response = await postRequest(`RecallOrder?OrderMasterId=${lastOrderId}`);

      if (response.data.Response) {

        const orderData = response.data.Data;
        const recalledItems = [];


        setItemLessReason(response.data.DataSet?.Table3 || []);

        setOrderCancelReason(response.data.DataSet?.Table4 || []);

        const mainOrderTaxPercent = response.data.DataSet.Table && response.data.DataSet.Table.length > 0
          ? parseFloat(response.data.DataSet.Table[0].GSTPercent) || 0
          : 0;


        orderData.forEach(mainItem => {
          const itemTaxPercent = parseFloat(mainItem.TaxPercent) || mainOrderTaxPercent;

          if (mainItem.DealDetail && mainItem.DealDetail.length > 0) {
            const dealSelections = {};
            const optionQuantities = {};


            const dealItemsByDealItemId = {};
            mainItem.DealDetail.forEach(dealItem => {
              if (!dealItemsByDealItemId[dealItem.DealItemId]) {
                dealItemsByDealItemId[dealItem.DealItemId] = [];
              }
              dealItemsByDealItemId[dealItem.DealItemId].push(dealItem);
            });


            Object.entries(dealItemsByDealItemId).forEach(([dealItemId, dealItemGroup]) => {
              if (dealItemId === "4434") {

                const selectedDrink = dealItemGroup[0];
                dealSelections[dealItemId] = {
                  id: selectedDrink.ProductDetailId,
                  productDetailId: selectedDrink.ProductDetailId,
                  name: selectedDrink.SizeName || selectedDrink.ProductName,
                  price: parseFloat(selectedDrink.Price || 0)
                };
              } else {

                dealSelections[dealItemId] = dealItemGroup.map(item => ({
                  id: item.ProductDetailId,
                  productDetailId: item.ProductDetailId,
                  name: item.ProductName,
                  price: parseFloat(item.Price || 0)
                }));


                dealItemGroup.forEach(item => {
                  if (item.Quantity > 1) {
                    optionQuantities[`${dealItemId}-${item.ProductDetailId}`] = item.Quantity;
                  }
                });
              }
            });

            let dealSelectionsTotal = 0;
            Object.values(dealSelections).forEach(selection => {
              if (Array.isArray(selection)) {
                // multiple selections
                selection.forEach(s => {
                  dealSelectionsTotal += parseFloat(s.price || 0);
                });
              } else if (selection && typeof selection === "object") {
                // single selection (like drinks)
                dealSelectionsTotal += parseFloat(selection.price || 0);
              }
            });
            const recalledItem = {
              id: Date.now() + Math.random(),
              ProductId: mainItem.ProductId,
              name: mainItem.ProductName,
              quantity: mainItem.Quantity,
              price: parseFloat(mainItem.PriceWithoutGST || mainItem.Price) + dealSelectionsTotal,
              basePrice: parseFloat(mainItem.PriceWithoutGST || mainItem.Price),
              description: mainItem.ProductDetailName,
              ProductDetailId: mainItem.ProductDetailId,
              SizeId: mainItem.SizeId,
              SizeName: mainItem.SizeName,
              FlavourId: mainItem.FlavourId,
              FlavourName: mainItem.FlavourName,
              GSTPercentage: itemTaxPercent,
              SpecialInstructions: mainItem.SpecialInstruction || "",
              dealSelections: dealSelections,
              optionQuantities: optionQuantities,
              discountPercent: mainItem.DiscountPercent || 0,
              DepartmentId: mainItem.DepartmentId || null,
              DepartmentName: mainItem.DepartmentName || null,
              IsKot: mainItem.IsKot,
              OrderDetailId: mainItem.OrderDetailId || null,
              discountAmount: parseFloat(mainItem.DiscountAmount || 0),
              IsSent: mainItem.IsSent,
            };

            recalledItems.push(recalledItem);
          } else {

            recalledItems.push({
              id: Date.now() + Math.random(),
              ProductId: mainItem.ProductId,
              name: mainItem.ProductName,
              quantity: mainItem.Quantity,
              // price: parseFloat(mainItem.PriceWithGST || mainItem.Price),
              price: parseFloat(mainItem.PriceWithoutGST || mainItem.Price),
              basePrice: parseFloat(mainItem.PriceWithoutGST || mainItem.Price),
              description: mainItem.ProductDetailName,
              ProductDetailId: mainItem.ProductDetailId,
              SizeId: mainItem.SizeId,
              SizeName: mainItem.SizeName,
              FlavourId: mainItem.FlavourId,
              FlavourName: mainItem.FlavourName,
              GSTPercentage: itemTaxPercent,
              SpecialInstructions: mainItem.SpecialInstruction || "",
              dealSelections: {},
              optionQuantities: {},
              discountPercent: mainItem.DiscountPercent || 0,
              DepartmentId: mainItem.DepartmentId || null,
              DepartmentName: mainItem.DepartmentName || null,
              IsKot: mainItem.IsKot,
              OrderDetailId: mainItem.OrderDetailId || null,
              discountAmount: parseFloat(mainItem.DiscountAmount || 0),
              IsSent: mainItem.IsSent,

            });
          }
        });

        setOrderItems(recalledItems);


        // setOrderKotItems([{ ...recalledItems, IsKot: true, IsLess: false }]);

        setOrderKotItems(
          recalledItems.map(item => ({
            ...item,
            // IsKot: true,
            IsKot: item.IsKot,
            IsLess: false
          }))
        );

        if (response.data.DataSet.Table && response.data.DataSet.Table.length > 0) {

          const orderData = response.data.DataSet.Table[0];

          const taxOptions = [{
            GSTId: orderData.GSTId,
            GSTPercentage: mainOrderTaxPercent,
            PaymentMode: "Tax",
            PaymentModeId: orderData.PaymentTypeId
          }];



          setCurrentOrder({
            ...currentOrder,
            orderMode: orderData.OrderModeId,
            orderModeName: orderData.OrderModeName,
            customerName: orderData.CustomerName,
            phoneNumber: orderData.PhoneNumber,
            address: orderData.CompleteAddress,
            orderSource: orderData.OrderSourceId,
            orderNubmer: orderData.OrderNumber,
            OrderMasterId: orderData.OrderMasterId,
            orderSourceName: orderData.OrderSourceName,
            branchId: orderData.BranchId,
            customerId: orderData.CustomerId,
            phoneId: orderData.PhoneId,
            customerAddressId: orderData.CustomerAddressId,
            deliveryCharges: orderData.DeliveryCharges,
            gstPercent: orderData.GSTPercent,
            Table11: taxOptions,
            Table15: response?.data?.DataSet?.Table2 || [],
            branchName: orderData.BranchName || "",
            tableId: orderData.TableId || null,
            tableName: orderData.TableName || null,
            waiterId: orderData.WaiterId || null,
            waiterName: orderData.WaiterName || null,
            billPrintCount: orderData.BillPrintCount || 0,
            orderDateTime: orderData.OrderDateTime,
            totalAmountWithoutGST: orderData.TotalAmountWithoutGST,
            gstAmount: orderData.GSTAmount,
            discountAmount: orderData.DiscountAmount,
            netBill: (orderData.TotalAmountWithoutGST + orderData.GSTAmount + orderData.DeliveryCharges - orderData.DiscountAmount),
            paymentTermId: orderData.PaymentTermId || null,
            specialInstructions: orderData.SpecialInstruction || "",
          });
        }


        // // console.log("Current Order after recall:", currentOrder);

        try {
          const menuData = await fetchMenuData(
            currentOrder?.branchId,
            currentOrder?.areaId,
            currentOrder?.orderSource
          );


          if (menuData) {
            // Update the current order with menu data
            setCurrentOrder(prevOrder => ({
              ...prevOrder,
              ...menuData
            }));

            setCategories(menuData.categories);
            setProducts(menuData.products);
          }
        } catch (menuError) {
          console.error("Error fetching menu data:", menuError);
          alert("Order recalled successfully but couldn't refresh menu data");
        }

        // // console.log("Recalled items with tax:", recalledItems);
        setIsRecalledOrder(true);

      } else {
        alert("Failed to recall order: " + (response.data.Message || "Unknown error"));
      }
    } catch (error) {
      console.error("Error recalling order:", error);
      alert("An error occurred while recalling the order");
    }
  };

  // const handleUpdateQuantity = (itemId, newQuantity) => {
  //   setOrderItems(prevItems =>
  //     newQuantity <= 0
  //       ? prevItems.filter(item => item.id !== itemId)
  //       : prevItems.map(item =>
  //         item.id === itemId ? { ...item, quantity: newQuantity } : item
  //       )
  //   );

  //   
  //   const itemCopy = orderItems.find(item => item.id === itemId);

  //   if (itemCopy) {
  //     if (newQuantity <= 0) {
  //       setOrderKotItems([...orderKotItems, {
  //         ...itemCopy
  //         , IsLess: true
  //         , IsKot: false
  //         , quantity: itemCopy.quantity
  //       }]);
  //     }
  //     else {
  //       if (newQuantity > itemCopy.quantity) {
  //         setOrderKotItems([...orderKotItems, {
  //           ...itemCopy
  //           , IsLess: false
  //           , IsKot: false
  //           , quantity: newQuantity - itemCopy.quantity
  //         }]);
  //       }
  //       else if (newQuantity < itemCopy.quantity) {
  //         setOrderKotItems([...orderKotItems, {
  //           ...itemCopy
  //           , IsLess: true
  //           , IsKot: false
  //           , quantity: itemCopy.quantity - newQuantity
  //         }]);
  //       }
  //     }
  //   };
  // }






  // const handleUpdateQuantity = (itemId, newQuantity) => {
  //   
  //   // // console.log("🔄 handleUpdateQuantity called:", { itemId, newQuantity });

  //   const orderItemsCopy = [...orderItems];

  //   const itemCopy = orderItemsCopy.find(item => item.id === itemId);

  // const itemToRemove = orderItemsCopy.find(item => item.id === itemId);

  // // if (itemToRemove) {
  // //   // // console.log("📦 Item to process:", {
  // //     name: itemToRemove.name,
  // //     // IsKot: itemToRemove.IsKot,
  // //     hasDealSelections: !!(itemToRemove.dealSelections && Object.keys(itemToRemove.dealSelections).length > 0),
  // //     dealSelections: itemToRemove.dealSelections
  // //   });
  // // }

  // if (itemToRemove) {
  //   if (newQuantity <= 0) {
  //     setOrderItems(orderItemsCopy.filter(item => item.id !== itemId));
  //   }
  //   else {
  //     setOrderItems(orderItemsCopy.map(item =>
  //       item.id === itemId ? { ...item, quantity: newQuantity } : item
  //     ));
  //   }
  // }
  // else if (itemToRemove) {
  //   // // console.log("🔻 Processing LESS items for KOT item");

  //   if (newQuantity <= 0) {
  //     setOrderItems(orderItemsCopy.filter(item => item.id !== itemId));
  //   }
  //   else {
  //     setOrderItems(orderItemsCopy.map(item =>
  //       item.id === itemId ? { ...item, quantity: newQuantity } : item
  //     ));
  //   }

  //   const lessOrderItem = {
  //     OrderMasterId: lastOrderId || null,
  //     ProductDetailId: itemToRemove.ProductDetailId,
  //     Quantity: itemToRemove.quantity,
  //     PriceWithoutGST: itemToRemove.basePrice,
  //     AmountWithoutGST: itemToRemove.basePrice,
  //     SpecialInstruction: itemToRemove.SpecialInstructions,
  //     ProductDetailName: itemToRemove.name,
  //     dealSelections: itemToRemove.dealSelections || {}

  //   };

  //   const updatedOrderItems = [...orderLessItems];

  //   updatedOrderItems.push(lessOrderItem);

  //   // Check if dealSelections exists and has content before processing
  //   if (itemToRemove.dealSelections && Object.keys(itemToRemove.dealSelections).length > 0) {
  //     // // console.log("✅ Processing deal selections for less items:", itemToRemove.dealSelections);
  //     Object.values(itemToRemove.dealSelections).forEach(dealItemsArray => {
  //       // Check if dealItemsArray is an array and has items
  //       if (Array.isArray(dealItemsArray) && dealItemsArray.length > 0) {
  //         dealItemsArray.forEach(item => {
  //           const newDealItem = {
  //             OrderMasterId: lastOrderId,
  //             ProductDetailId: item.productDetailId,
  //             Quantity: item.quantity || 1,
  //             PriceWithoutGST: item.price,
  //             AmountWithoutGST: item.price,
  //             ProductDetailName: item.name,
  //           };
  //           updatedOrderItems.push(newDealItem);
  //         });
  //       } else if (dealItemsArray && dealItemsArray.productDetailId) {
  //         // Handle single object case (not array)
  //         const newDealItem = {
  //           OrderMasterId: lastOrderId,
  //           ProductDetailId: dealItemsArray.productDetailId,
  //           Quantity: dealItemsArray.quantity || 1,
  //           PriceWithoutGST: dealItemsArray.price,
  //           AmountWithoutGST: dealItemsArray.price,
  //           ProductDetailName: dealItemsArray.name,
  //         };
  //         updatedOrderItems.push(newDealItem);
  //       }
  //     });
  //   } else {
  //     // // console.log("⚠️ No deal selections found for less items processing");
  //   }
  //   setOrderLessItems(updatedOrderItems);
  // }
  // // setOrderItems(prevItems =>
  // //   newQuantity <= 0
  // //     ? prevItems.filter(item => item.id !== itemId)
  // //     : prevItems.map(item =>
  // //       item.id === itemId ? { ...item, quantity: newQuantity } : item
  // //     )
  // // );
  // };

  const handleUpdateSpecialInstruction = (itemId, instruction) => {
    setOrderItems((prevItems) =>
      prevItems.map((item) =>
        item.id === itemId
          ? { ...item, SpecialInstructions: instruction || null }
          : item
      )
    );

    // Also update in orderKotItems if the item exists there
    setOrderKotItems((prevKotItems) =>
      prevKotItems.map((item) =>
        item.id === itemId
          ? { ...item, SpecialInstructions: instruction || null }
          : item
      )
    );
  };

  const handleUpdateDiscount = (updatedItems) => {
    if (!updatedItems || !Array.isArray(updatedItems) || updatedItems.length === 0) {
      return;
    }

    // Update orderItems with discount information
    setOrderItems((prevItems) => {
      return prevItems.map((item) => {
        // Find the corresponding updated item by id or ProductDetailId
        const updatedItem = updatedItems.find(
          (updated) => updated.id === item.id || updated.ProductDetailId === item.ProductDetailId
        );

        if (updatedItem) {
          // Update discountPercent and discountAmount from the updated item
          return {
            ...item,
            discountPercent: updatedItem.discountPercent || 0,
            discountAmount: updatedItem.discountAmount || 0,
            // Preserve basePrice if it exists in updatedItem, otherwise keep current basePrice
            basePrice: updatedItem.basePrice !== undefined ? updatedItem.basePrice : item.basePrice,
            // Preserve price if it exists in updatedItem, otherwise keep current price
            price: updatedItem.price !== undefined ? updatedItem.price : item.price
          };
        }

        // If item is not in updatedItems, check if discount should be removed
        // (Items not in the discount list should keep their current state)
        return item;
      });
    });

  };

  const handleItemLessReasonConfirm = (selectedReason) => {

    if (!pendingQuantityUpdate || !pendingItemForReason) {
      setShowItemLessReasonDialog(false);
      return;
    }

    const { itemId, newQuantity } = pendingQuantityUpdate;
    const itemCopy = pendingItemForReason;

    // Step 1️⃣ — Update main order items
    setOrderItems((prevItems) =>
      newQuantity <= 0
        ? prevItems.filter((item) => item.id !== itemId)
        : prevItems.map((item) =>
          item.id === itemId ? { ...item, quantity: newQuantity } : item
        )
    );

    // Step 2️⃣ — Add to KOT items with reason
    const reducedQty = itemCopy.quantity - newQuantity;

    const baseReason =
      selectedReason?.ItemLessReasonName ||
      selectedReason?.ReasonName ||
      "";
    const customReason = selectedReason?.CustomReason?.trim();
    const combinedReason =
      baseReason && customReason
        ? `${baseReason} - ${customReason}`
        : baseReason || customReason || null;

    setOrderKotItems((prev) => [
      ...prev,
      {
        ...itemCopy,
        IsLess: true,
        IsKot: false,
        quantity: reducedQty, // reduced part
        Action: "Decreased",
        Timestamp: new Date().toISOString(),
        ItemLessReasonId: selectedReason?.ItemLessReasonId || null,
        ItemLessReason: combinedReason,
      },
    ]);

    // Reset state
    setShowItemLessReasonDialog(false);
    setPendingQuantityUpdate(null);
    setPendingItemForReason(null);
  };

  const handleUpdateQuantity = (itemId, newQuantity) => {

    // Step 1️⃣ — Get current item snapshot before change
    const itemCopy = orderKotItems.find((item) => item.id === itemId);

    // Step 2️⃣ — Check if we need to show popup for KOT items with decreased quantity
    if (itemCopy && itemCopy.IsKot && newQuantity < itemCopy.quantity) {
      // Show popup to select item less reason BEFORE updating quantity
      setPendingQuantityUpdate({ itemId, newQuantity, originalQuantity: itemCopy.quantity });
      setPendingItemForReason(itemCopy);
      setShowItemLessReasonDialog(true);
      return; // Don't update quantity yet, wait for reason selection
    }

    // Step 3️⃣ — Update main order items (only if not showing popup)
    setOrderItems((prevItems) =>
      newQuantity <= 0
        ? prevItems.filter((item) => item.id !== itemId)
        : prevItems.map((item) =>
          item.id === itemId ? { ...item, quantity: newQuantity } : item
        )
    );

    if (!itemCopy) return;

    // // console.log("orderKotItems", orderKotItems);

    // Step 4️⃣ — KOT logic only applies if IsKot === true
    if (itemCopy.IsKot) {
      // Case A: item completely removed
      if (newQuantity <= 0) {
        setOrderKotItems((prev) => [
          ...prev,
          {
            ...itemCopy,
            // KOTId: uuidv4(),
            IsLess: true,
            IsKot: false,
            quantity: itemCopy.quantity, // full removal
            Action: "Removed",
            Timestamp: new Date().toISOString(),
            ItemLessReasonId: null,
            ItemLessReason: null,
          },
        ]);
      }

      // Case B: quantity increased
      else if (newQuantity > itemCopy.quantity) {
        const addedQty = newQuantity - itemCopy.quantity;

        setOrderKotItems((prev) => [
          ...prev,
          {
            ...itemCopy,
            // KOTId: uuidv4(),
            IsLess: false,
            IsKot: false,
            quantity: addedQty, // only added part
            Action: "Increased",
            Timestamp: new Date().toISOString(),
            ItemLessReasonId: null,
            ItemLessReason: null,
          },
        ]);
      }
    }
    else if (!itemCopy.IsKot) {

      if (newQuantity > itemCopy.quantity) {
        const addedQty = newQuantity - itemCopy.quantity;

        setOrderKotItems((prevKotItems) => {
          // find if this product already exists in KOT items
          const existingIndex = prevKotItems.findIndex(
            (kot) => kot.ProductDetailId === itemCopy.ProductDetailId
          );

          if (existingIndex !== -1) {
            // ✅ update existing KOT item quantity
            const updatedKotItems = [...prevKotItems];
            updatedKotItems[existingIndex] = {
              ...updatedKotItems[existingIndex],
              quantity: newQuantity, // or maybe += addedQty depending on logic
              Action: "Increased",
              Timestamp: new Date().toISOString(),
              ItemLessReasonId: null,
              ItemLessReason: null,
            };
            return updatedKotItems;
          } else {
            // ✅ add as a new KOT item
            return [
              ...prevKotItems,
              {
                ...itemCopy,
                // KOTId: uuidv4(),
                IsLess: false,
                IsKot: false,
                quantity: addedQty,
                Action: "Increased",
                Timestamp: new Date().toISOString(),
                ItemLessReasonId: null,
                ItemLessReason: null,
              },
            ];
          }
        });
      }
      else if (newQuantity < itemCopy.quantity && newQuantity > 0) {

        setOrderKotItems((prevKotItems) => {
          // find if this product already exists in KOT items
          const existingIndex = prevKotItems.findIndex(
            (kot) => kot.ProductDetailId === itemCopy.ProductDetailId
          );

          if (existingIndex !== -1) {
            // ✅ update existing KOT item quantity
            const updatedKotItems = [...prevKotItems];
            updatedKotItems[existingIndex] = {
              ...updatedKotItems[existingIndex],
              quantity: newQuantity, // or maybe += addedQty depending on logic
              Action: "Decreased",
              Timestamp: new Date().toISOString(),
              IsLess: true,
              ItemLessReasonId: null,
              ItemLessReason: null,
            };
            return updatedKotItems;
          } else {
            // ✅ add as a new KOT item
            return [
              ...prevKotItems,
              {
                ...itemCopy,
                // KOTId: uuidv4(),
                IsLess: true,
                IsKot: false,
                quantity: newQuantity,
                Action: "Decreased",
                Timestamp: new Date().toISOString(),
                ItemLessReasonId: null,
                ItemLessReason: null,
              },
            ];
          }
        });
      }
      else if (newQuantity <= 0) {

        setOrderKotItems((prevItems) =>
          prevItems.filter((item) => item.id !== itemId)
        );
      }
    }
  };

  const handleOrderCancel = () => {
    if (!currentOrder?.OrderMasterId) {
      message.error("No order selected to cancel");
      return;
    }
    setShowOrderCancelReasonDialog(true);
  };

  const handleOrderCancelReasonConfirm = async (selectedReason) => {
    if (!currentOrder?.OrderMasterId) {
      message.error("No order selected to cancel");
      return;
    }

    try {
      const response = await postRequest("/UpdateCoverWaiterRider", {
        OperationId: 8,
        CompanyId: userData.CompanyId,
        UserId: userData.UserId,
        UserIP: "1.2.2.1",
        OrderMasterId: currentOrder.OrderMasterId,
        BranchId: currentOrder.branchId,
        OrderCancelReasonId: selectedReason.OrderCancelReasonId,
        RiderId: null,
        WaiterId: null,
        TableId: null,
      });

      if (response?.error === true) {
        message.error(response?.errorMessage);
        return;
      }
      if (response?.data?.response === false) {
        message.error(response?.DataSet?.Table?.errorMessage);
        return;
      }

      message.success(response.successMessage || "Order cancelled successfully");
      setShowOrderCancelReasonDialog(false);

      // Clear the order after successful cancellation
      handleClearAll();
    } catch (error) {
      console.error("Error cancelling order:", error);
      message.error("An error occurred while cancelling the order");
    }
  };

  useEffect(() => {
    if (categories.length > 0 && activeCategory === null) {
      setActiveCategory(categories[0].CategoryId.toString());
    }
  }, [categories, activeCategory]);

  // const filteredProducts = activeCategory
  //   ? products.filter(product => product.CategoryId.toString() === activeCategory)
  //   : products;

  const filteredProducts = products.filter(product => {
    const matchCategory = activeCategory
      ? product.CategoryId.toString() === activeCategory
      : true;

    const matchSearch = product.ProductName.toLowerCase().includes(searchQuery.toLowerCase()) ||
      product.ProductDescription?.toLowerCase().includes(searchQuery.toLowerCase());

    return matchCategory && matchSearch;
  });

  return (
    <div className="h-[88dvh] flex bg-background">
      {/* Sidebar */}
      <Sidebar
        activeCategory={activeCategory}
        onCategoryChange={setActiveCategory}
        categories={categories}
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col">
        {/* Top Action Bar */}
        <TopActionBar
          activeMode={activeMode}
          onModeChange={handleNewOrder}
          currentOrder={currentOrder}
          lastOrderId={lastOrderId}
          onRecallOrder={recallLastOrder}
          isRecalledOrder={isRecalledOrder}
          roleId={userData.RoleId}
          orderModes={orderMode}
        />

        {/* Food Items Grid */}
        <div className="flex-1 p-6 overflow-y-auto">
          {/* Order Type Display */}
          {currentOrder && isRecalledOrder && (
            <div className="bg-muted/50 border border-border rounded-lg p-4 mb-6">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-semibold text-lg">Recalled Order</h3>
                  <p className="text-sm text-muted-foreground">
                    Order Number: <span className="font-medium text-primary">{currentOrder.orderNubmer?.toUpperCase()}</span> |
                    Type: <span className="font-medium text-primary">{currentOrder.orderModeName?.toUpperCase()}</span> |
                    Source: <span className="font-medium text-primary">{currentOrder.orderSourceName}</span> |
                    Branch: <span className="font-medium text-primary">{currentOrder.branchName}</span> |
                    {/* Customer: <span className="font-medium text-primary">{currentOrder.customerName}</span> |
                    Phone: <span className="font-medium text-primary cursor-pointer underline" onClick={() => setIsOrderHistoryOpen(true)}>{currentOrder.phoneNumber}</span> */}

                    {
                      currentOrder.customerName ?
                        <>
                          Customer: <span className="font-medium text-primary">{currentOrder.customerName}</span> |
                        </> : <></>
                    }
                    <> </>
                    {
                      currentOrder.phoneNumber ?
                        <>
                          Phone: <span className="font-medium text-primary cursor-pointer underline" onClick={() => setIsOrderHistoryOpen(true)}>{currentOrder.phoneNumber}</span> |
                        </> : <></>
                    }
                    <> </>
                    {
                      currentOrder.tableName ?
                        <>
                          Table: <span className="font-medium text-primary">{currentOrder.tableName}</span> |
                        </> : <></>
                    }
                    <> </>
                    {
                      currentOrder.waiterName ?
                        <>
                          Waiter: <span className="font-medium text-primary">{currentOrder.waiterName}</span> |
                        </> : <></>
                    }

                  </p>
                </div>
              </div>
            </div>
          )}
          {currentOrder && !isRecalledOrder && (
            <div className="bg-muted/50 border border-border rounded-lg p-4 mb-6">
              <div className="flex items-center justify-between">
                <div>
                  <h3 className="font-semibold text-lg">Active Order</h3>
                  <p className="text-sm text-muted-foreground">
                    Type: <span className="font-medium text-primary">{currentOrder.orderModeName?.toUpperCase()}</span> |
                    Source: <span className="font-medium text-primary">{currentOrder.orderSourceName}</span> |
                    {
                      currentOrder.branchName ?
                        <>
                          Branch:
                          <span className="font-medium text-primary cursor-pointer underline"
                            onClick={() => {
                              if (!isRecalledOrder) {
                                setIsNewOrderDialogOpen(true);
                              } else {
                                setIsOrderHistoryOpen(true);
                              }
                            }}>{currentOrder.branchName}
                          </span> |
                        </> : <></>
                    }
                    {
                      currentOrder.customerName ?
                        <>
                          Customer: <span className="font-medium text-primary">{currentOrder.customerName}</span> |
                        </> : <></>
                    }
                    <> </>
                    {
                      currentOrder.phoneNumber ?
                        <>
                          Phone: <span className="font-medium text-primary cursor-pointer underline" onClick={() => setIsOrderHistoryOpen(true)}>{currentOrder.phoneNumber}</span> |
                        </> : <></>
                    }
                    <> </>
                    {
                      currentOrder.tableName ?
                        <>
                          Table: <span className="font-medium text-primary">{currentOrder.tableName}</span> |
                        </> : <></>
                    }
                    <> </>
                    {
                      currentOrder.waiterName ?
                        <>
                          Waiter: <span className="font-medium text-primary">{currentOrder.waiterName}</span> |
                        </> : <></>
                    }

                  </p>
                  {currentOrder.address && currentOrder.orderModeName?.toLowerCase() != "pickup" && (
                    <p className="text-sm text-muted-foreground">
                      Address: <span className="font-medium text-primary">{currentOrder.address}</span>
                    </p>
                  )}
                </div>
              </div>
            </div>
          )}
          {/* Search Bar */}
          <div className="relative mb-4 w-1/4">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
            <Input
              type="text"
              placeholder="Search products..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="pl-10 bg-background border-border"
            />
          </div>
          <div className="grid grid-cols-6 gap-4">
            {isLoading ? (
              <div className="col-span-6 flex justify-center items-center">
                <>
                  <svg
                    className="animate-spin -ml-1 mr-2 h-10 w-10"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    style={{ color: 'hsl(174 98% 24%)' }}>
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4">
                    </circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    ></path>
                  </svg>
                </>
              </div>
            ) : (
              filteredProducts.map((product) => (

                <FoodItem
                  key={product.ProductId}
                  name={product.ProductName}
                  price={product.ProductPrice}
                  description={product.ProductDescription}
                  image={product.ProductImage ? `${process.env.REACT_APP_BASEURL}${product.ProductImage}` : null}
                  onSelect={() => handleItemSelect(product)}
                />
              ))
            )}
          </div>
        </div>

      </div>

      {/* Order Summary */}
      <OrderSummary
        orderType="Takeaway"
        items={orderItems}
        onPayment={handlePayment}
        onRemoveItem={handleRemoveItem}
        onClearAll={handleClearAll}
        currentOrder={currentOrder}
        // lastOrderId={lastOrderId}
        lastOrderId={order?.OrderMasterId || null}
        onRecallOrder={recallLastOrder}
        setLastOrderId={setLastOrderId}
        onUpdateQuantity={handleUpdateQuantity}
        isRecalledOrder={isRecalledOrder}
        onResetRecalledOrder={resetRecalledOrderState}
        DayShiftCounterData={DayShiftCounterData}
        OrderMasterId={order?.OrderMasterId || null}
        orderKotItems={orderKotItems}
        onUpdateDiscount={handleUpdateDiscount}
        onUpdateSpecialInstruction={handleUpdateSpecialInstruction}
        onUpdateItems={handleUpdateItemsCallback}
        onCancelOrder={handleOrderCancel}
        orderCancelReasons={orderCancelReason}
      />

      {showProductModal && selectedProduct && (
        <ProductDetailModal
          product={selectedProduct}
          onClose={() => setShowProductModal(false)}
          // onAddToOrder={(newItem) => {
          //   // Always add each main product as a separate row in the cart
          //   setOrderItems([...orderItems, newItem]);

          //   const newOrderItem = {
          //     OrderMasterId: lastOrderId != null ? lastOrderId : null,
          //     ProductDetailId: newItem.ProductDetailId,
          //     Quantity: newItem.quantity,
          //     PriceWithoutGST: newItem.basePrice,
          //     AmountWithoutGST: newItem.basePrice,
          //     SpecialInstruction: newItem.SpecialInstructions,
          //   };

          //   const updatedOrderItems = [...orderKotItems];

          //   updatedOrderItems.push(newOrderItem);

          //   Object.values(newItem.dealSelections).forEach(dealItemsArray => {
          //     // dealItemsArray is the inner array of product objects
          //     dealItemsArray.forEach(item => {
          //       // Now 'item' is the correct object with productDetailId
          //       const newDealItem = {
          //         OrderMasterId: lastOrderId,
          //         ProductDetailId: item.productDetailId,
          //         Quantity: item.quantity || 1,
          //         PriceWithoutGST: item.price,
          //         AmountWithoutGST: item.price
          //       };
          //       // Add newDealItem to your order items list
          //       updatedOrderItems.push(newDealItem);
          //     });
          //   });

          //   setOrderKotItems([...updatedOrderItems, { ...newItem, IsKot: false, IsLess: false }]);
          //   setShowProductModal(false);
          // }}
          currentOrder={currentOrder}
          onAddProductDetailToOrder={(newOrderItemDetails) => {

            // Ensure we always work with an array of items
            const itemsArray = Array.isArray(newOrderItemDetails)
              ? newOrderItemDetails
              : [newOrderItemDetails];

            // 1) Add all main products as separate rows in the cart
            setOrderItems((prev) => [...prev, ...itemsArray]);

            // 2) Build KOT items for each main product and its deal selections
            const updatedKotItems = [...orderKotItems];

            itemsArray.forEach((newItem) => {
              // Parent/main product row for KOT
              const parentKotItem = {
                OrderMasterId: lastOrderId != null ? lastOrderId : null,
                ProductDetailId: newItem.ProductDetailId,
                Quantity: newItem.quantity,
                PriceWithoutGST: newItem.basePrice,
                AmountWithoutGST: newItem.basePrice,
                SpecialInstruction: newItem.SpecialInstructions,
              };

              updatedKotItems.push(parentKotItem);

              // Child deal items (toppings/options)
              if (newItem.dealSelections && Object.keys(newItem.dealSelections).length > 0) {
                Object.entries(newItem.dealSelections).forEach(([dealItemId, selection]) => {
                  // Radio/single selection
                  if (selection && !Array.isArray(selection)) {
                    updatedKotItems.push({
                      OrderMasterId: lastOrderId != null ? lastOrderId : null,
                      ProductDetailId: selection.productDetailId,
                      Quantity: 1,
                      PriceWithoutGST: selection.price,
                      AmountWithoutGST: selection.price,
                    });
                  }
                  // Checkbox/multi selection
                  else if (Array.isArray(selection)) {
                    selection.forEach((sel) => {
                      const key = `${dealItemId}-${sel.id}`;
                      const qty =
                        newItem.optionQuantities && newItem.optionQuantities[key]
                          ? newItem.optionQuantities[key]
                          : 1;

                      updatedKotItems.push({
                        OrderMasterId: lastOrderId != null ? lastOrderId : null,
                        ProductDetailId: sel.productDetailId,
                        Quantity: qty,
                        PriceWithoutGST: sel.price,
                        AmountWithoutGST: sel.price,
                      });
                    });
                  }
                });
              }

              // Also track the full main item in KOT context
              updatedKotItems.push({
                ...newItem,
                IsKot: false,
                IsLess: false,
              });
            });

            setOrderKotItems(updatedKotItems);
            setShowProductModal(false);
          }}
        />
      )}

      <CustomerOrderHistoryDialog
        open={isOrderHistoryOpen}
        onOpenChange={setIsOrderHistoryOpen}
        initialPhoneNumber={currentOrder?.phoneNumber}
      />

      <ItemLessReasonDialog
        open={showItemLessReasonDialog}
        onOpenChange={(open) => {
          setShowItemLessReasonDialog(open);
          if (!open) {
            // If dialog is closed without confirming, no need to revert since we didn't update quantity yet
            setPendingQuantityUpdate(null);
            setPendingItemForReason(null);
          }
        }}
        itemLessReasons={itemLessReason}
        itemName={pendingItemForReason?.ItemLessReasonName || ""}
        onConfirm={handleItemLessReasonConfirm}
      />

      <NewOrderDialog
        open={isNewOrderDialogOpen}
        onOpenChange={setIsNewOrderDialogOpen}
        onSubmit={(orderData) => {
          handleNewOrder(orderData);
          setIsNewOrderDialogOpen(false);
        }}
        initialData={currentOrder ? {
          branchId: currentOrder.branchId,
          branchName: currentOrder.branchName,
          customerName: currentOrder.customerName,
          phoneNumber: currentOrder.phoneNumber,
          address: currentOrder.address,
          orderMode: currentOrder.orderMode,
          orderSource: currentOrder.orderSource,
          customerId: currentOrder.customerId,
          phoneId: currentOrder.phoneId,
          customerAddressId: currentOrder.customerAddressId,
          areaId: currentOrder.areaId,
          tableId: currentOrder.tableId,
          waiterId: currentOrder.waiterId
        } : null}
      />

      <OrderCancelReasonDialog
        open={showOrderCancelReasonDialog}
        onOpenChange={setShowOrderCancelReasonDialog}
        orderCancelReasons={orderCancelReason}
        onConfirm={handleOrderCancelReasonConfirm}
      />
    </div>
  );
};

export default CDMS;